import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDifferenceIgnored: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconDifferenceIgnored"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM7.96973 14.9697L9.03027 16.0303L16.0303 9.03027L14.9697 7.96973L7.96973 14.9697Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDifferenceIgnored;
